<template>
  <div v-if="entry && entry.weekId" class="challenges">
    <h2><strong>Tréninkový plán – {{ entry.title }}</strong> <br class="inline-block md:hidden"><i>({{ entry.dateFromTo }})</i></h2>
    <div class="flex flex-wrap">

      <div class="col col-purple">
        <div class="inner">

          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="75.5" height="50.728" viewBox="0 0 75.5 50.728">
              <g id="pilates" transform="translate(0 -83.996)">
                <path id="Path_18" data-name="Path 18"
                      d="M72.434,128.591H51.05a30.081,30.081,0,0,0,2.267-3h0c.527-.794,1.038-1.637,1.518-2.505a1.106,1.106,0,1,0-1.936-1.07c-.316.572-.647,1.131-.987,1.672l-1.032-.3c-3.944-1.226-6.13-2.346-7.883-5.354a11.343,11.343,0,0,0,3.639-8.032l3.822.448a3.851,3.851,0,1,0,.773-7.663l-3.045-.012a9.448,9.448,0,0,1,1.524-1.949,7.374,7.374,0,0,0,5.975.358,3.737,3.737,0,0,1,2.048,2.017,6.74,6.74,0,0,1,.136,3.851,50.985,50.985,0,0,1-2.842,10.44,1.106,1.106,0,0,0,2.056.817,53.185,53.185,0,0,0,2.969-10.894,8.686,8.686,0,0,0-.3-5.131,6.04,6.04,0,0,0-1.875-2.383A7.383,7.383,0,0,0,60.5,94.247V92.7a7.393,7.393,0,0,0-.174-1.592,3.667,3.667,0,1,0-4.447-5.263A7.394,7.394,0,0,0,45.7,92.7v1.548a7.375,7.375,0,0,0,2.2,5.258,11.277,11.277,0,0,0-2.188,3.253l-10.229-.04a33.911,33.911,0,0,0-7.51,1.292l-5-3.767a23.755,23.755,0,0,1-3.5-4.832l-1.73-3.5a2.631,2.631,0,0,0-4.972,1.28l.233,6.139a3.971,3.971,0,0,0,2.213,3.413,6.826,6.826,0,0,1,2.577,1.78l.015.016.013.017,2.246,2.51A1.106,1.106,0,1,0,21.72,105.6l-1.457-1.628,1.956-1.524L26.941,106a2.056,2.056,0,0,0,1.838,1.9l.809.095,2,1.51c4.578,3.448,6.813,6.509,9.087,8.9,2.155,4.153,4.919,5.654,9.553,7.093l.372.109a22.629,22.629,0,0,1-2.6,2.986H37.016c-1.213-2.233-2.21-4.174-3.1-5.9-2.5-4.865-4.146-8.079-7.481-11.819l-1.272-1.422a1.106,1.106,0,0,0-1.648,1.475l1.27,1.419c3.147,3.528,4.745,6.642,7.164,11.356.75,1.461,1.577,3.073,2.55,4.89H3.066a3.067,3.067,0,0,0,0,6.133H72.434a3.066,3.066,0,0,0,0-6.133ZM47.915,94.247V92.7a5.19,5.19,0,0,1,.033-.578H51.8a.982.982,0,0,1,.981.981,3.19,3.19,0,0,0,.8,2.111l2.733,3.1A5.19,5.19,0,0,1,47.915,94.247ZM60.09,86.635a1.454,1.454,0,0,1-.563,2.406,7.45,7.45,0,0,0-1.749-2.069A1.456,1.456,0,0,1,60.09,86.635Zm-6.989.878A5.192,5.192,0,0,1,58.286,92.7v1.548a5.151,5.151,0,0,1-.555,2.331L55.238,93.75a.98.98,0,0,1-.245-.649A3.2,3.2,0,0,0,51.8,89.909H48.732a5.185,5.185,0,0,1,4.368-2.4ZM35.477,104.93l15.676.061a1.642,1.642,0,0,1-.436,3.254l-20.953-2.457a30.978,30.978,0,0,1,5.714-.858Zm-16.723-2.59a9.947,9.947,0,0,0-2.555-1.575,1.761,1.761,0,0,1-.982-1.514l-.233-6.139a.418.418,0,0,1,.78-.215l1.73,3.5a21,21,0,0,0,3.131,4.489ZM33.906,108.5l10.534,1.235c-.218,2.352-.637,4.464-2.75,6.485a61.654,61.654,0,0,0-7.784-7.72Zm38.528,24.01H3.066a.855.855,0,0,1,0-1.709H72.434a.855.855,0,0,1,0,1.709Z"
                      transform="translate(0 0)" fill="#fff"/>
              </g>
            </svg>
          </div>

          <h3>Body and mind</h3>
          <h3 class="level">Začátečníci</h3>

          <a target="_blank" v-for="video in easyBm" :key="video.title" :href="`/detail?video=${video.videoId}`" class="link-video">
            <div class="img">
              <img :src="video.image" alt="Foto">
              <svg id="play-button" xmlns="http://www.w3.org/2000/svg" width="30.83" height="30.83"
                   viewBox="0 0 30.83 30.83">
                <g id="Group_74" data-name="Group 74">
                  <path id="Path_30" data-name="Path 30"
                        d="M15.415,0A15.415,15.415,0,1,0,30.83,15.415,15.415,15.415,0,0,0,15.415,0Zm6.492,15.906a1.1,1.1,0,0,1-.494.494v.005L12.6,20.81a1.1,1.1,0,0,1-1.593-.991V11.011a1.1,1.1,0,0,1,1.593-.985l8.808,4.4A1.1,1.1,0,0,1,21.907,15.906Z"
                        fill="#fff"/>
                </g>
              </svg>
            </div>
            <div class="text">
              <h4>{{ video.dow }}</h4>
              <p>{{ video.title }}</p>
            </div>
          </a>
        </div>
      </div>

      <div class="col col-pink">
        <div class="inner">

          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="75.5" height="50.728" viewBox="0 0 75.5 50.728">
              <g id="pilates" transform="translate(0 -83.996)">
                <path id="Path_18" data-name="Path 18"
                      d="M72.434,128.591H51.05a30.081,30.081,0,0,0,2.267-3h0c.527-.794,1.038-1.637,1.518-2.505a1.106,1.106,0,1,0-1.936-1.07c-.316.572-.647,1.131-.987,1.672l-1.032-.3c-3.944-1.226-6.13-2.346-7.883-5.354a11.343,11.343,0,0,0,3.639-8.032l3.822.448a3.851,3.851,0,1,0,.773-7.663l-3.045-.012a9.448,9.448,0,0,1,1.524-1.949,7.374,7.374,0,0,0,5.975.358,3.737,3.737,0,0,1,2.048,2.017,6.74,6.74,0,0,1,.136,3.851,50.985,50.985,0,0,1-2.842,10.44,1.106,1.106,0,0,0,2.056.817,53.185,53.185,0,0,0,2.969-10.894,8.686,8.686,0,0,0-.3-5.131,6.04,6.04,0,0,0-1.875-2.383A7.383,7.383,0,0,0,60.5,94.247V92.7a7.393,7.393,0,0,0-.174-1.592,3.667,3.667,0,1,0-4.447-5.263A7.394,7.394,0,0,0,45.7,92.7v1.548a7.375,7.375,0,0,0,2.2,5.258,11.277,11.277,0,0,0-2.188,3.253l-10.229-.04a33.911,33.911,0,0,0-7.51,1.292l-5-3.767a23.755,23.755,0,0,1-3.5-4.832l-1.73-3.5a2.631,2.631,0,0,0-4.972,1.28l.233,6.139a3.971,3.971,0,0,0,2.213,3.413,6.826,6.826,0,0,1,2.577,1.78l.015.016.013.017,2.246,2.51A1.106,1.106,0,1,0,21.72,105.6l-1.457-1.628,1.956-1.524L26.941,106a2.056,2.056,0,0,0,1.838,1.9l.809.095,2,1.51c4.578,3.448,6.813,6.509,9.087,8.9,2.155,4.153,4.919,5.654,9.553,7.093l.372.109a22.629,22.629,0,0,1-2.6,2.986H37.016c-1.213-2.233-2.21-4.174-3.1-5.9-2.5-4.865-4.146-8.079-7.481-11.819l-1.272-1.422a1.106,1.106,0,0,0-1.648,1.475l1.27,1.419c3.147,3.528,4.745,6.642,7.164,11.356.75,1.461,1.577,3.073,2.55,4.89H3.066a3.067,3.067,0,0,0,0,6.133H72.434a3.066,3.066,0,0,0,0-6.133ZM47.915,94.247V92.7a5.19,5.19,0,0,1,.033-.578H51.8a.982.982,0,0,1,.981.981,3.19,3.19,0,0,0,.8,2.111l2.733,3.1A5.19,5.19,0,0,1,47.915,94.247ZM60.09,86.635a1.454,1.454,0,0,1-.563,2.406,7.45,7.45,0,0,0-1.749-2.069A1.456,1.456,0,0,1,60.09,86.635Zm-6.989.878A5.192,5.192,0,0,1,58.286,92.7v1.548a5.151,5.151,0,0,1-.555,2.331L55.238,93.75a.98.98,0,0,1-.245-.649A3.2,3.2,0,0,0,51.8,89.909H48.732a5.185,5.185,0,0,1,4.368-2.4ZM35.477,104.93l15.676.061a1.642,1.642,0,0,1-.436,3.254l-20.953-2.457a30.978,30.978,0,0,1,5.714-.858Zm-16.723-2.59a9.947,9.947,0,0,0-2.555-1.575,1.761,1.761,0,0,1-.982-1.514l-.233-6.139a.418.418,0,0,1,.78-.215l1.73,3.5a21,21,0,0,0,3.131,4.489ZM33.906,108.5l10.534,1.235c-.218,2.352-.637,4.464-2.75,6.485a61.654,61.654,0,0,0-7.784-7.72Zm38.528,24.01H3.066a.855.855,0,0,1,0-1.709H72.434a.855.855,0,0,1,0,1.709Z"
                      transform="translate(0 0)" fill="#fff"/>
              </g>
            </svg>
          </div>

          <h3>Dynamické a taneční</h3>
          <h3 class="level">Začátečníci</h3>

          <a target="_blank" v-for="video in easyDt" :key="video.title" :href="`/detail?video=${video.videoId}`" class="link-video">
            <div class="img">
              <img :src="video.image" alt="Foto">
              <svg id="play-button" xmlns="http://www.w3.org/2000/svg" width="30.83" height="30.83"
                   viewBox="0 0 30.83 30.83">
                <g id="Group_74" data-name="Group 74">
                  <path id="Path_30" data-name="Path 30"
                        d="M15.415,0A15.415,15.415,0,1,0,30.83,15.415,15.415,15.415,0,0,0,15.415,0Zm6.492,15.906a1.1,1.1,0,0,1-.494.494v.005L12.6,20.81a1.1,1.1,0,0,1-1.593-.991V11.011a1.1,1.1,0,0,1,1.593-.985l8.808,4.4A1.1,1.1,0,0,1,21.907,15.906Z"
                        fill="#fff"/>
                </g>
              </svg>
            </div>
            <div class="text">
              <h4>{{ video.dow }}</h4>
              <p>{{ video.title }}</p>
            </div>
          </a>

        </div>
      </div>

      <div class="col col-purple">
        <div class="inner">

          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="46.328" height="67.038" viewBox="0 0 46.328 67.038">
              <g id="dancing" transform="translate(-79.092 0)">
                <g id="Group_49" data-name="Group 49" transform="translate(79.092 0)">
                  <path id="Path_29" data-name="Path 29"
                        d="M124.829,61.091l-6.3-10.021a1.309,1.309,0,0,0-2.217,1.394l3.019,4.8-2.649,1.818c-6.656-8.5-17.214-21.969-17.214-21.969a1.309,1.309,0,0,0-1.857-.208l-8.238,6.7a1.309,1.309,0,0,0-.4,1.463l3.891,10.706L89.528,57.29l-4.406-8.8a6.837,6.837,0,0,1,.922-7.525l8.178-9.549,8.256-1.582a7.666,7.666,0,0,1,4.719,7.684,1.31,1.31,0,0,0,.2.773l2.641,4.2a1.309,1.309,0,0,0,2.217-1.394l-2.425-3.854a10.353,10.353,0,0,0-5.9-9.623l.058-5.2a4.488,4.488,0,0,0,1.367-5.161,5.554,5.554,0,0,0,5.594-9.22h9.437a4.018,4.018,0,1,0,0-8.037H109.21a14.064,14.064,0,0,0-10.1,4.3L92.8,10.883A6.153,6.153,0,0,0,90.162,15.6L84.4,13.764a4.037,4.037,0,0,0-5.065,2.449,4.018,4.018,0,0,0,2.525,5.176s6.617,2.486,6.638,2.493a22.387,22.387,0,0,0,2.694.672l.788,5.46-7.921,9.25a9.45,9.45,0,0,0-1.275,10.4L90.36,64.8a4.012,4.012,0,0,0,3.594,2.236,4.076,4.076,0,0,0,1.514-.294,4.02,4.02,0,0,0,2.3-5.13l-6.02-16.563,6.481-5.273c3.325,4.243,15.806,20.17,20.172,25.747a3.916,3.916,0,0,0,5.335.783l.051-.036a3.833,3.833,0,0,0,1.044-5.182ZM92.772,16.211a3.915,3.915,0,0,1,.389-1.886A3.519,3.519,0,0,1,96.3,12.41h.015l5.154.022a5.513,5.513,0,0,0,.6,2.073,4.493,4.493,0,0,0-3.063.458,10.786,10.786,0,0,1-1.694.741A10.594,10.594,0,0,1,92.772,16.211Zm14.234-1.321a2.938,2.938,0,1,1,2.938-2.938,2.941,2.941,0,0,1-2.938,2.938Zm-6-8.773a11.433,11.433,0,0,1,8.209-3.5h11.17a1.4,1.4,0,1,1,0,2.8H108.353a5.723,5.723,0,0,0-4.039,1.677,5.59,5.59,0,0,0-2.436,2.721L97.47,9.8ZM82.749,18.928l-.062-.022A1.4,1.4,0,0,1,81.8,17.1a1.446,1.446,0,0,1,1.8-.839l6.264,2a13.174,13.174,0,0,0,8.292-.074,13.418,13.418,0,0,0,2.107-.922,1.882,1.882,0,0,1,2.506.664h0a1.88,1.88,0,0,1-.71,2.64,14.538,14.538,0,0,1-7.605,1.745,20.566,20.566,0,0,1-5.133-.913Zm11.576,6q.412.02.824.02a17.083,17.083,0,0,0,6.2-1.173l-.041,3.621-6.873,1.317L93.884,24.9c.147.01.294.022.441.029ZM94.5,64.312a1.411,1.411,0,0,1-1.8-.683l-2-4,3.055-1.389,1.55,4.264A1.413,1.413,0,0,1,94.5,64.312Zm27.784-.183-.051.036a1.3,1.3,0,0,1-1.769-.254L118.3,61.148l2.427-1.665,1.889,3A1.216,1.216,0,0,1,122.282,64.129Z"
                        transform="translate(-79.092 0)" fill="#fff"/>
                  <circle id="Ellipse_18" data-name="Ellipse 18" cx="1.309" cy="1.309" r="1.309"
                          transform="translate(33.879 45.472)" fill="#fff"/>
                </g>
              </g>
            </svg>
          </div>

          <h3>Body and mind</h3>
          <h3 class="level">Pokročilí</h3>

          <a target="_blank" v-for="video in proBm" :key="video.id" :href="`/detail?video=${video.videoId}`" class="link-video">
            <div class="img">
              <img :src="video.image" alt="Foto">
              <svg id="play-button" xmlns="http://www.w3.org/2000/svg" width="30.83" height="30.83"
                   viewBox="0 0 30.83 30.83">
                <g id="Group_74" data-name="Group 74">
                  <path id="Path_30" data-name="Path 30"
                        d="M15.415,0A15.415,15.415,0,1,0,30.83,15.415,15.415,15.415,0,0,0,15.415,0Zm6.492,15.906a1.1,1.1,0,0,1-.494.494v.005L12.6,20.81a1.1,1.1,0,0,1-1.593-.991V11.011a1.1,1.1,0,0,1,1.593-.985l8.808,4.4A1.1,1.1,0,0,1,21.907,15.906Z"
                        fill="#fff"/>
                </g>
              </svg>
            </div>
            <div class="text">
              <h4>{{ video.dow }}</h4>
              <p>{{ video.title }}</p>
            </div>
          </a>

        </div>
      </div>

      <div class="col col-pink">
        <div class="inner">

          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="46.328" height="67.038" viewBox="0 0 46.328 67.038">
              <g id="dancing" transform="translate(-79.092 0)">
                <g id="Group_49" data-name="Group 49" transform="translate(79.092 0)">
                  <path id="Path_29" data-name="Path 29"
                        d="M124.829,61.091l-6.3-10.021a1.309,1.309,0,0,0-2.217,1.394l3.019,4.8-2.649,1.818c-6.656-8.5-17.214-21.969-17.214-21.969a1.309,1.309,0,0,0-1.857-.208l-8.238,6.7a1.309,1.309,0,0,0-.4,1.463l3.891,10.706L89.528,57.29l-4.406-8.8a6.837,6.837,0,0,1,.922-7.525l8.178-9.549,8.256-1.582a7.666,7.666,0,0,1,4.719,7.684,1.31,1.31,0,0,0,.2.773l2.641,4.2a1.309,1.309,0,0,0,2.217-1.394l-2.425-3.854a10.353,10.353,0,0,0-5.9-9.623l.058-5.2a4.488,4.488,0,0,0,1.367-5.161,5.554,5.554,0,0,0,5.594-9.22h9.437a4.018,4.018,0,1,0,0-8.037H109.21a14.064,14.064,0,0,0-10.1,4.3L92.8,10.883A6.153,6.153,0,0,0,90.162,15.6L84.4,13.764a4.037,4.037,0,0,0-5.065,2.449,4.018,4.018,0,0,0,2.525,5.176s6.617,2.486,6.638,2.493a22.387,22.387,0,0,0,2.694.672l.788,5.46-7.921,9.25a9.45,9.45,0,0,0-1.275,10.4L90.36,64.8a4.012,4.012,0,0,0,3.594,2.236,4.076,4.076,0,0,0,1.514-.294,4.02,4.02,0,0,0,2.3-5.13l-6.02-16.563,6.481-5.273c3.325,4.243,15.806,20.17,20.172,25.747a3.916,3.916,0,0,0,5.335.783l.051-.036a3.833,3.833,0,0,0,1.044-5.182ZM92.772,16.211a3.915,3.915,0,0,1,.389-1.886A3.519,3.519,0,0,1,96.3,12.41h.015l5.154.022a5.513,5.513,0,0,0,.6,2.073,4.493,4.493,0,0,0-3.063.458,10.786,10.786,0,0,1-1.694.741A10.594,10.594,0,0,1,92.772,16.211Zm14.234-1.321a2.938,2.938,0,1,1,2.938-2.938,2.941,2.941,0,0,1-2.938,2.938Zm-6-8.773a11.433,11.433,0,0,1,8.209-3.5h11.17a1.4,1.4,0,1,1,0,2.8H108.353a5.723,5.723,0,0,0-4.039,1.677,5.59,5.59,0,0,0-2.436,2.721L97.47,9.8ZM82.749,18.928l-.062-.022A1.4,1.4,0,0,1,81.8,17.1a1.446,1.446,0,0,1,1.8-.839l6.264,2a13.174,13.174,0,0,0,8.292-.074,13.418,13.418,0,0,0,2.107-.922,1.882,1.882,0,0,1,2.506.664h0a1.88,1.88,0,0,1-.71,2.64,14.538,14.538,0,0,1-7.605,1.745,20.566,20.566,0,0,1-5.133-.913Zm11.576,6q.412.02.824.02a17.083,17.083,0,0,0,6.2-1.173l-.041,3.621-6.873,1.317L93.884,24.9c.147.01.294.022.441.029ZM94.5,64.312a1.411,1.411,0,0,1-1.8-.683l-2-4,3.055-1.389,1.55,4.264A1.413,1.413,0,0,1,94.5,64.312Zm27.784-.183-.051.036a1.3,1.3,0,0,1-1.769-.254L118.3,61.148l2.427-1.665,1.889,3A1.216,1.216,0,0,1,122.282,64.129Z"
                        transform="translate(-79.092 0)" fill="#fff"/>
                  <circle id="Ellipse_18" data-name="Ellipse 18" cx="1.309" cy="1.309" r="1.309"
                          transform="translate(33.879 45.472)" fill="#fff"/>
                </g>
              </g>
            </svg>
          </div>

          <h3>Dynamické a taneční</h3>
          <h3 class="level">Pokročilí</h3>

          <a target="_blank" v-for="video in proDt" :key="video.id" :href="`/detail?video=${video.videoId}`" class="link-video">
            <div class="img">
              <img :src="video.image" alt="Foto">
              <svg id="play-button" xmlns="http://www.w3.org/2000/svg" width="30.83" height="30.83"
                   viewBox="0 0 30.83 30.83">
                <g id="Group_74" data-name="Group 74">
                  <path id="Path_30" data-name="Path 30"
                        d="M15.415,0A15.415,15.415,0,1,0,30.83,15.415,15.415,15.415,0,0,0,15.415,0Zm6.492,15.906a1.1,1.1,0,0,1-.494.494v.005L12.6,20.81a1.1,1.1,0,0,1-1.593-.991V11.011a1.1,1.1,0,0,1,1.593-.985l8.808,4.4A1.1,1.1,0,0,1,21.907,15.906Z"
                        fill="#fff"/>
                </g>
              </svg>
            </div>
            <div class="text">
              <h4>{{ video.dow }}</h4>
              <p>{{ video.title }}</p>
            </div>
          </a>

        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>

.challenges {
  @apply text-center pt-50 px-20 min-h-[100vh];
}

.col {
  @apply flex-initial w-full lg:w-1/2 2xl:w-1/4 px-0 lg:px-20 mb-70;
}

.inner {
  @apply shadow bg-white rounded-[13px] px-20 pb-20;
}

h2 {
  @apply normal-case text-[27px] sm:text-[30px] mb-[75px];
}

h3 {
  @apply normal-case text-20 font-bold text-black mb-[2px];
}

h3.level {
  @apply mb-20;
}

h4 {
  @apply normal-case text-base font-bold text-black mb-0;
}

.icon {
  @apply mx-auto w-[104px] h-[104px] flex relative mb-[-30px] top-[-52px] items-center justify-center rounded-[12px] shadow;
}

.link-video {
  @apply w-full flex mb-25 flex-wrap no-underline;
}

.link-video:last-of-type {
  @apply mb-5;
}

.link-video .img {
  @apply w-[105px] h-[70px] rounded-[6px] flex-none relative flex items-center justify-center;
}

.link-video .img svg {
  @apply relative z-[10];
}

.link-video .img img {
  @apply w-full h-full object-cover absolute top-0 left-0;
}

.link-video .text {
  @apply flex-none pt-[8px] xs:pt-0 xs:flex-1 xs:pl-[12px] text-left w-full xs:w-auto;
}

.link-video p {
  @apply mb-0 text-black text-base;
}


.col-purple .icon {
  @apply bg-purple;
}

.col-purple h3.level {
  @apply text-purple;
}

.col-purple h4 {
  @apply text-purple;
}

.col-pink .icon {
  @apply bg-pink;
}

.col-pink h3.level {
  @apply text-pink;
}

.col-pink h4 {
  @apply text-pink;
}


</style>

<script>
import axios from "axios";

const query = `query Plan {
  entries(type: "plans") {
    id
    title,
    ... on plans_plans_Entry {
      weekId,
      dateFromTo,
      zacatecniciBodyMind {
        \t__typename
         ... on zacatecniciBodyMind_activity_BlockType {
          video {
            ... on videos_videos_Entry {
              title,
              id,
              thumbnail {
                url
              }
            }
          }
        }
        ... on zacatecniciBodyMind_rest_BlockType {
          __typename
          id
          typeHandle,
        }
      }
      zacatecniciDynamickeTanecni {
         ... on zacatecniciDynamickeTanecni_activity_BlockType {
          id,
          typeHandle
          video {
            id,
            title,
            ... on videos_videos_Entry {
              thumbnail {
                url
              }
            }
          }
        }
        ... on zacatecniciDynamickeTanecni_rest_BlockType {
          id,
          typeHandle
        }
      }
      pokrociliBodyMind {
         ... on pokrociliBodyMind_activity_BlockType {
          id,
          typeHandle
          video {
            ... on videos_videos_Entry {
              title,
              id,
              thumbnail {
                url
              }
            }
          }
        }
        ... on pokrociliBodyMind_rest_BlockType {
          id,
          typeHandle
        }
      }
      pokrociliDynamickeATanecni {
         ... on pokrociliDynamickeATanecni_activity_BlockType {
          video {
            ... on videos_videos_Entry {
              title,
              id,
              thumbnail {
                url
              }
            }
          }
        }
        ... on pokrociliDynamickeATanecni_rest_BlockType {
          id,
          typeHandle
        }
      }
    }

  }
}`;

export default {
  data() {
    return {
      entry: {}
    }
  },
  computed: {
    easyBm() {
      return this.daysFixer(this.entry?.zacatecniciBodyMind);
    },
    proBm() {
      return this.daysFixer(this.entry?.pokrociliBodyMind);
    },
    easyDt() {
      return this.daysFixer(this.entry?.zacatecniciDynamickeTanecni);
    },
    proDt() {
      return this.daysFixer(this.entry?.pokrociliDynamickeATanecni);
    },
  },
  methods: {
    daysFixer(data) {

      console.log(data);

      const weekdays = {
          1: 'Pondělí',
          2: 'Úterý',
          3: 'Středa',
          4: 'Čtvrtek',
          5: 'Pátek'
      }

      let videos = [];
      for(let i in data) {
        console.log(data[i]);
        // eslint-disable-next-line no-prototype-builtins
        if(data[i].hasOwnProperty('typeHandle') && data[i].typeHandle === 'rest') {
          continue;
        }
        const videoObject = data[i].video[0];
        let video = {
          dow: weekdays[parseInt(i)+1],
          title: videoObject.title,
          image: videoObject.thumbnail[0].url,
          videoId: videoObject.id,
        };

        videos.push(video);
      }

      return videos;
    }
  },
  async mounted() {
    try {
      const result = await axios({
        method: "POST",
        url: "https://elixir-console.spacek.dev/api",
        data: {
          query: query
        }
      });
      console.log(result);
      this.entry = result.data.data.entries[0];
    } catch (error) {
      console.error(error);
    }
  }
}
</script>
